import { render } from "./Index.vue?vue&type=template&id=0181aa74"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Customers/Teams/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0181aa74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0181aa74', __exports__)) {
    api.reload('0181aa74', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=0181aa74", () => {
    api.rerender('0181aa74', render)
  })

}


export default __exports__